import type { ReactNode } from 'react'
import { Card } from '@/components/ui/Card'

interface AuthCardProps {
  title: string
  description?: string
  children: ReactNode
}

/** Painel branco centralizado usado por login, cadastro e recuperação. */
export function AuthCard({ title, description, children }: AuthCardProps) {
  return (
    <div className="mx-auto w-full max-w-[340px] px-4 py-8 sm:py-12">
      <Card className="p-6">
        <h1 className="text-[19px] font-bold leading-tight text-ink lg:text-[22px]">
          {title}
        </h1>
        {description && (
          <p className="mt-2 text-[13px] leading-relaxed text-ink-faint">{description}</p>
        )}
        <div className="mt-5">{children}</div>
      </Card>
    </div>
  )
}
